import { Alert, AlertTitle, Box, CircularProgress, useTheme, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { motion } from "framer-motion";
import React, { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UserAuth } from "../context/AuthContext";
import Header from "./Header";

import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Tab from "@mui/material/Tab";
import { miCatalogoCursos, misCursosFetch, misLogrosFetch, obtenerMiPlanFormativo } from "../Redux/universidadInterna";
import { COLUMNSCATALOGO, COLUMNSMISCURSOS, COLUMNSMISLOGROS, COLUMNSPLANFORMATIVOP } from "../columnas/columnaUniversidadInterna";
import TokenContext from "../context/TokenContext";
import Tabla from "./Tabla";
import TablaCatalogo from "./tablas/TablaCatalogo";
import ModalInfo from "./modales/ModalInfo";

const UniversidadInterna = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const token = useContext(TokenContext);
  const { empleado } = UserAuth();

  const [valuePrimerTab, setValuePrimerTab] = React.useState("1"); //value del tablist
  const planFormativoSelector = useSelector((store) => store.universidadInterna.planFormativo);
  const loadingMiPlanFormativo = useSelector((store) => store.universidadInterna.loadingMiPlanFormativo);
  const misCursosSelector = useSelector((store) => store.universidadInterna.misCursos);
  const loadingMisCursos = useSelector((store) => store.universidadInterna.loadingMisCursos);
  const misLogrosSelector = useSelector((store) => store.universidadInterna.misLogros);
  const loadingMisLogros = useSelector((store) => store.universidadInterna.loadingMisLogros);
  const catalogoSelector = useSelector((store) => store.universidadInterna.catalogo)
  const loadingCatalogoSelector = useSelector((store) => store.universidadInterna.loadingCatalogo)

  const [loadPendPFP, setLoadPendPFP] = React.useState(false);
  const [planFormativoPri, setPlanFormativoPri] = React.useState([]);
  const [columnasPlanFormativoPri, setColumnasPlanFormativoPri] = React.useState(COLUMNSPLANFORMATIVOP);

  const [loadCatalogo, setLoadCatalogo] = React.useState(false);
  const [catalogo, setCatalogo] = React.useState([]);
  const [columnasCatalogo, setColumnaCatalogo] = React.useState(COLUMNSCATALOGO)

  const [loadMisCursos, setLoadMisCursos] = React.useState(false);
  const [misCursos, setMisCursos] = React.useState([]);
  const [columnasMisCursos, setColumnasMisCursos] = React.useState(COLUMNSMISCURSOS);

  const [loadMisLogros, setLoadMisLogros] = React.useState(false);
  const [misLogros, setMisLogros] = React.useState([]);
  const [columnasMisLogros, setColumnasMisLogros] = React.useState(COLUMNSMISLOGROS);

  const [openModal, setOpenModal] = React.useState(false);
  const [maestroCursoID, setMaestroCursoID] = React.useState('');
  const [eventoCapacitacionID, setEventoCapacitacionID] = React.useState('');

  const handleChangePrimerTAB = (event, newValue) => {
    setValuePrimerTab(newValue);
  };


  React.useEffect(() => {
    if (token && empleado?.usuarioPortalRh?.length > 0) {
      dispatch(obtenerMiPlanFormativo(token, empleado.usuarioPortalRh));
      dispatch(miCatalogoCursos(token, empleado.usuarioPortalRh));
      dispatch(misCursosFetch(token, empleado.usuarioPortalRh));
      dispatch(misLogrosFetch(token, empleado.usuarioPortalRh));
    }
  }, [token, empleado]);

  React.useEffect(() => {
    setLoadPendPFP(loadingMiPlanFormativo);
    setLoadCatalogo(loadingCatalogoSelector)
    setLoadMisCursos(loadingMisCursos);
    setLoadMisLogros(loadingMisLogros);
  }, [loadingMiPlanFormativo, loadingCatalogoSelector, loadingMisCursos, loadingMisLogros]);

  React.useEffect(() => {
    if (planFormativoSelector?.length > 0) {
      var array = []
      planFormativoSelector.forEach(element => {
        var objeto = {
          id: element.new_participanteporeventodecapacitacionid,
          eje: element["af.new_name"],
          new_maestrodecurso: element["ag.new_name"],
          new_maestrodecursoid: element["ag.new_maestrodecursoid"],
          new_name: element.new_name,
          _new_eventodecapacitacion_value: element._new_eventodecapacitacion_value,
          new_eventodecapacitacion: element["_new_eventodecapacitacion_value@OData.Community.Display.V1.FormattedValue"]
        }
        array.push(objeto)
      });
      setPlanFormativoPri(array)
    }
  }, [planFormativoSelector])

  React.useEffect(() => {
    if (catalogoSelector?.length > 0) {
      var array = []
      catalogoSelector.forEach(element => {
        var objeto = {
          id: element.new_participanteporeventodecapacitacionid,
          af_new_name: element["af.new_name"],
          ag_new_name: element["ag.new_name"],
          new_maestrodecursoid: element["ag.new_maestrodecursoid"],
          new_name: element.new_name,
          _new_eventodecapacitacion_value: element._new_eventodecapacitacion_value,
          new_eventodecapacitacion: element["_new_eventodecapacitacion_value@OData.Community.Display.V1.FormattedValue"]
        }
        array.push(objeto)
      });
      setCatalogo(array)
    }
  }, [catalogoSelector])

  React.useEffect(() => {
    if (misCursosSelector?.length > 0) {
      var array = []
      misCursosSelector.forEach(element => {
        var objeto = {
          id: element.new_participanteporeventodecapacitacionid,
          new_name: element.new_name,
          statuscode: element["statuscode@OData.Community.Display.V1.FormattedValue"],
          _new_eventodecapacitacion_value: element._new_eventodecapacitacion_value,
          new_eventodecapacitacion: element["_new_eventodecapacitacion_value@OData.Community.Display.V1.FormattedValue"],
          new_eventodecapacitacionid: element["aa.new_eventodecapacitacionid"],
        }
        array.push(objeto)
      });
      setMisCursos(array)
    }
  }, [misCursosSelector])

  React.useEffect(() => {
    if (misLogrosSelector?.length > 0) {
      var array = []
      misLogrosSelector.forEach(element => {
        var objeto = {
          id: element.new_participanteporeventodecapacitacionid,
          new_programa: element["ab.new_programa@OData.Community.Display.V1.FormattedValue"],
          new_cursomaestro: element["ab.new_cursomaestro@OData.Community.Display.V1.FormattedValue"],
          new_institucion: element["ab.new_institucion"],
          new_fechainicio: element["ab.new_fechainicio@OData.Community.Display.V1.FormattedValue"],
          new_fechafinalizacion: element["ab.new_fechafinalizacion@OData.Community.Display.V1.FormattedValue"],
          new_modalidaddecurso: element["ab.new_modalidaddecurso@OData.Community.Display.V1.FormattedValue"],
          new_programa: element["ab.new_programa@OData.Community.Display.V1.FormattedValue"],
          new_name: element.new_name,
          _new_eventodecapacitacion_value: element._new_eventodecapacitacion_value,
          new_eventodecapacitacion: element["_new_eventodecapacitacion_value@OData.Community.Display.V1.FormattedValue"]
        }
        array.push(objeto)
      });
      setMisLogros(array)
    }
  }, [misLogrosSelector])

  //======|| handlers del modal +INFO ||====== //
  const handleCloseModal = () => {
    setOpenModal(false)
    setEventoCapacitacionID('')
    setMaestroCursoID('')
  };

  const handleOpenModalInfo = (id, maestrocursoid) => {
    setOpenModal(true);
    setEventoCapacitacionID(id)
    setMaestroCursoID(maestrocursoid)
  };
  //======================================================= //

  return (
    <motion.div
      initial={{ opacity: 0, y: 100 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -100 }}
      transition={{ duration: 0.5, ease: "easeInOut" }}
    >
      <Box m="1.5rem 2.5rem">
        <Header
          title={"Universidad Interna"}
          subtitle="Conocé y aplicá a las formaciones asignadas por tu rol y desafíos."
        />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
            <TabContext value={valuePrimerTab}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <TabList
                  aria-label="scrollable force tabs example"
                  onChange={handleChangePrimerTAB}
                  variant="scrollable"
                  scrollButtons="auto"
                  allowScrollButtonsMobile
                  textColor="secondary"
                  indicatorColor="secondary"
                >
                  <Tab label="Mi plan formativo" value="1" sx={{ fontWeight: "bold", fontSize: "16px" }} />
                  <Tab label="Mis cursos" value="2" sx={{ fontWeight: "bold", fontSize: "16px" }} />
                  <Tab label="Mis logros" value="3" sx={{ fontWeight: "bold", fontSize: "16px" }} />
                </TabList>
              </Box>
              <TabPanel value="1">
                {loadPendPFP ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      height: "100%",
                      py: 2,
                    }}
                  >
                    <CircularProgress color="secondary" />
                  </Box>
                ) : planFormativoPri.length > 0 ? (
                  <TablaCatalogo columnas={columnasPlanFormativoPri} lineas={planFormativoPri} acciones={true} handleOpen={handleOpenModalInfo} />
                ) : (
                  <Alert severity="info">
                    <AlertTitle>Info</AlertTitle>
                    Aún no tienes registros de <strong>Mi plan formativo</strong>.
                  </Alert>
                )}

                {loadCatalogo ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      height: "100%",
                      py: 2,
                    }}
                  >
                    <CircularProgress color="secondary" />
                  </Box>
                ) : catalogo.length > 0 ? (
                  <>
                    <Box sx={{ p: 2 }} display="flex" flexDirection="column" alignItems="center">
                      <Typography variant="h4" component="div" sx={{ fontWeight: 'bold', mb: 1 }} color="secondary">
                        Catálogo
                      </Typography>
                    </Box>
                    <TablaCatalogo columnas={columnasCatalogo} lineas={catalogo} acciones={true} handleOpen={handleOpenModalInfo} />
                  </>

                ) : (
                  <Box sx={{ mt: 2 }}>
                    <Alert severity="info">
                      <AlertTitle>Info</AlertTitle>
                      No existen registros de <strong>Catálogo</strong>.
                    </Alert>
                  </Box>
                )}
              </TabPanel>
              <TabPanel value="2">
                {loadMisCursos ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      height: "100%",
                      py: 2,
                    }}
                  >
                    <CircularProgress color="secondary" />
                  </Box>
                ) : misCursos.length > 0 ? (
                  <TablaCatalogo columnas={columnasMisCursos} lineas={misCursos} />
                ) : (
                  <Alert severity="info">
                    <AlertTitle>Info</AlertTitle>
                    Aún no tienes registros de <strong>Mis cursos</strong>.
                  </Alert>
                )}
              </TabPanel>
              <TabPanel value="3">
                {loadMisLogros ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      height: "100%",
                      py: 2,
                    }}
                  >
                    <CircularProgress color="secondary" />
                  </Box>
                ) : misLogros.length > 0 ? (
                  <Tabla columnas={columnasMisLogros} lineas={misLogros} />
                ) : (
                  <Alert severity="info">
                    <AlertTitle>Info</AlertTitle>
                    Aún no tienes registros de <strong>Mis Logros</strong>.
                  </Alert>
                )}
              </TabPanel>
            </TabContext>
          </Grid>
        </Grid>
      </Box>
      <ModalInfo open={openModal} handleClose={handleCloseModal} eventocapacitacionid={eventoCapacitacionID} maestrocursoid={maestroCursoID} />
    </motion.div>
  );
};

export default UniversidadInterna;
